import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyValueChangeEvent } from '@ngx-formly/core/lib/models';
import { distinctUntilChanged, filter, Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'irembogov-custom-currency-format-input',
  templateUrl: './custom-currency-format-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCurrencyFormatInputComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy
{
  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  private subscription: Subscription | undefined;

  ngOnInit(): void {
    this.subscription = this.field.options?.fieldChanges
      ?.pipe(
        filter(
          (change: FormlyValueChangeEvent) =>
            change.field.key === this.field.key
        ),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b))
      )
      .subscribe(() => {
        this.cdRef.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
